<template lang="pug">
  div
    h2 Meine Bestellungen
    div.spinner.spinner-border.spinner-border-lg.text-primary(v-if="loading")
    template(v-else)
      table.table
        thead
          tr
            th #
            th Datum
            th Status
            th Preis
            th Menge
            th Kommentar
            th
        tbody
          template(v-if="orders.length === 0")
            tr
              td(colspan="7")
                div.mt-4.pa-2.alert.alert-info
                  | Es gibt noch keine Bestellungen.
          template(v-for="(order, ix) in orders")
            tr
              td {{ ix + 1 }}
              td {{ order.createdAt | dateFormatter }}
              td
                template(v-if="order.status === orderStatus.ORDER_STATUS_CREATED || order.status === orderStatus.ORDER_STATUS_PROCESSED")
                  | Bestellt
                template(v-if="order.status === orderStatus.ORDER_STATUS_SHIPPED")
                  | Gesendet
              td
                template(v-if="order.orderSummary && customer && customer.studentProducts === 1")
                  | {{ order.orderSummary.totalPriceB2c }}
                template(v-else-if="order.orderSummary")
                  | {{ order.orderSummary.totalPriceB2b }}
                template(v-else)
              td
                template(v-if="order.orderSummary")
                  | {{ order.orderSummary.totalQuantity }}
                template(v-else)
              td {{ order.note }}
              td.align-middle.text-center.no-wrap
                button.btn.btn-primary.btn-sm.mr-2(@click="showOrderDetails(order)")
                  svg(style="width:16px;height:16px" viewBox="0 0 24 24")
                    path(fill="currentColor" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z")
                button.btn.btn-primary.btn-sm(
                  @click="downloadInvoice(order)"
                  :disabled="!order.hasInvoice"
                  )
                  svg(style="width:16px;height:16px" viewBox="0 0 24 24")
                    path(fill="currentColor" d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z")

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import get from 'lodash.get'
import filters from '@/mixins/filters'

export default {
  name: 'OrderHistory',
  mixins: [filters],
  computed: {
    ...mapState({
      loading: state => !!state.orderFormService.loadingIndicators.getOrders,
      orders: state => get(state, 'orderFormService.latestRequests.getOrders.response.ordersList', []),
      orderStatus: state => state.orderFormService.enums.OrderStatus
    }),
    ...mapGetters('authentication', ['customer'])
  },
  methods: {
    ...mapActions('ui', [
      'downloadInvoice',
      'showOrder'
    ]),
    showOrderDetails (order) {
      this.showOrder({
        order: order
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .no-wrap
    white-space nowrap

  .spinner
    width 200px
    height 200px
    position absolute
    top calc(50% - 100px)
    left calc(50% - 100px)

    &.spinner-border
      border 1.25em solid currentColor
      border-right-color transparent
</style>
